import { faWheelchair } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import classNames from "classnames";

export function ControlledRichTextEditorCustomImage({ node, selected }: NodeViewProps) {
  const { src, alt, isDecorative } = node.attrs;

  const missingAlt = !alt || alt.trim() === "";
  const showAltWarning = !isDecorative && missingAlt;

  return (
    <NodeViewWrapper
      className={classNames("tw-relative tw-mb-[14px]", {
        "ProseMirror-selectednode": selected,
      })}
      data-drag-handle
    >
      <img
        className={classNames("tw-mb-[8px]", {
          "ProseMirror-selectednode": selected,
        })}
        src={src}
        alt={isDecorative ? "" : alt}
        data-is-decorative={isDecorative ? "true" : "false"}
      />
      {showAltWarning && (
        <div className='tw-absolute tw-bottom-0 tw-right-0 tw-m-2 tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-black/75 tw-px-2 tw-py-0.5 tw-text-sm tw-font-semibold tw-text-white'>
          <FontAwesomeIcon icon={faWheelchair} className='tw-h-3' />
          <span>Missing Alt Text</span>
        </div>
      )}
    </NodeViewWrapper>
  );
}
